import * as angular from "angular";

angular
  .module('bringoz.admin', [
    'uiGmapgoogle-maps',
    'satellizer',
    'ngMaterialDateRangePicker',
    'bringoz.admin.commons',
    'bringoz.admin.configuration-profiles',
    'bringoz.admin.contracts',
    'bringoz.admin.admins',
    'bringoz.admin.authentication',
    'bringoz.admin.persistence',
    'bringoz.admin.deliveries',
    'bringoz.admin.service-areas',
    'bringoz.admin.auctions',
    'bringoz.admin.agreements',
    'bringoz.admin.terms',
    'bringoz.admin.attachments',
    'bringoz.admin.pricePlan',
    'bringoz.admin.site-preferences',
    'bringoz.admin.billing-accounts',
    'bringoz.admin.accounts',
    'bringoz.admin.agents',
    'bringoz.admin.agent-inventory',
    'bringoz.admin.map',
    'bringoz.admin.orders',
    'bringoz.admin.user',
    'bringoz.admin.coordinations',
    'bringoz.admin.notifications',
    'bringoz.admin.lean-planning',
    'bringoz.admin.logistics-vehicle',
    'bringoz.admin.survey',
    'bringoz.admin.service-analysis',
    'bringoz.admin.organizations',
    'bringoz.admin.policies',
    'bringoz.admin.sites',
    'bringoz.admin.skills',
    'bringoz.admin.search',
    'bringoz.admin.addresses',
    'bringoz.admin.branches',
    'bringoz.admin.reports',
    'bringoz.admin.customers',
    'bringoz.admin.depots',
    'bringoz.admin.customers',
    'bringoz.admin.messages',
    'bringoz.admin.globals',
    'bringoz.admin.devices',
    'bringoz.admin.fulfillment',
    'bringoz.admin.text-templates',
    'bringoz.admin.batch',
    'bringoz.admin.point-of-sale',
    'bringoz.admin.vehicles',
    'bringoz.admin.webhooks',
    'bringoz.admin.tags',
    'bringoz.admin.working-slots',
    'bringoz.admin.schedule',
    'bringoz.admin.resources',
    'bringoz.admin.oms',
    'bringoz.admin.planning',
    'bringoz.admin.labels',
    'bringoz.admin.self-pickups',
    'bringoz.admin.sub-tasks',
    'bringoz.admin.itineraries',
    'bringoz.admin.wallets',
    'bringoz.admin.cancellation-reasons',
    'bringoz.admin.integrations',
    'bringoz.admin.expenses',
    'bringoz.admin.workload',
    'bringoz.admin.threePL',
    'bringoz.admin.ruleEngine',
    'bringoz.admin.document-management',
    'bringoz.admin.content-templates',
    'bringoz.admin.dashboards',
    'bringoz.admin.groups',
    'bringoz.admin.action-reasons',
    'bringoz.admin.order-planning-configuration',
    'bringoz.admin.teams',
    'bringoz.admin.scheduling-project',
    'bringoz.admin.recommendation',
    'bringoz.admin.ai-agents',
    'bringoz.admin.timekeeping',
    'bringoz.admin.service-points',
  ]);
